import { FunctionComponent } from 'react'
import { TableCell, TableRow } from '@mui/material'
import styles from './permissionsTable.module.scss'
import Checkbox from '@/components/_custom/Checkbox/Checkbox'

interface StaffAccessRowProps {
    title: string
    readChecked?: boolean
    setReadChecked?: (value: boolean) => void
    writeChecked?: boolean
    setWriteChecked?: (value: boolean) => void
    disabled?: boolean
    border?: boolean
}

const StaffAccessRow: FunctionComponent<StaffAccessRowProps> = ({
    title,
    readChecked,
    setReadChecked,
    writeChecked,
    setWriteChecked,
    disabled,
    border
}: StaffAccessRowProps) => {
    return (
        <TableRow>
            <TableCell className={!border ? styles.NoBorder : ''}>{title}</TableCell>
            <TableCell className={styles.NoBorder} align={'center'}>
                {setReadChecked && (
                    <Checkbox
                        checked={readChecked}
                        onChange={setReadChecked}
                        disabled={disabled}
                        className={styles.Checkbox}
                    />
                )}
            </TableCell>
            <TableCell className={styles.NoBorder} align={'center'}>
                {setWriteChecked && (
                    <Checkbox
                        checked={writeChecked}
                        onChange={setWriteChecked}
                        disabled={disabled}
                        className={styles.Checkbox}
                    />
                )}
            </TableCell>
        </TableRow>
    )
}

export default StaffAccessRow
